module.exports = __webpack_public_path__ + "static/media/Regresar.ebfbdb37.svg";